import byteliveApi from "./api/byteliveApi";
import { objectToQueryString } from "../utils";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const authRegisterByAdmin = (payload) => {
    return (dispatch) => {
        const queryString = objectToQueryString(payload);
        return byteliveApi
            .post(`/auth//register/admin`, payload)
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });
    };
};

export const authDeletebyAdmin = (email) => {
    return (dispatch) => {
        return byteliveApi
            .delete(`/auth/admin/${email}`)
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });
    };
};
